const TEMPLATES = {
  TEMPLATES: '/templates',
  TEMPLATES_ITEM: '/templates/:identifier'
}

export default TEMPLATES
